var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1533_218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1533_218)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1533_218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 74,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1533_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5367 3L5.95996 15.2528L11.424 60.868L40.5733 77L69.8731 60.6494L75.335 15.0358L40.5367 3Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8856 17.672L40.4553 6.87964V73.1457L66.7952 58.467L71.8853 17.672H71.8856Z",
    fill: "#A6120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83923 17.8661L14.5215 58.6617L40.4547 73.1454V6.87817L9.83951 17.8658L9.83923 17.8661Z",
    fill: "#DD1B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1067 42.1566L40.4549 46.2305H31.3362L27.0497 57.0264L19.0769 57.1748L40.4549 9.28638L49.1067 42.1568V42.1566ZM48.2703 40.1056L40.5125 24.6408L34.1488 39.8394H40.4547L48.2703 40.1059V40.1056Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4553 9.28613L40.5126 24.6408L47.7331 39.8513H40.4717L40.4553 46.2206L50.4963 46.2302L55.1892 57.1764L62.8181 57.3187L40.4553 9.28613Z",
    fill: "#B3B3B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/Angular.cbe369b117ec269a816333d6a2123ebf.svg";
export { ForwardRef as ReactComponent };